import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProgressArc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconProgressArc"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M12 5.25C13.2089 5.25 14.3955 5.57464 15.436 6.18999C16.4765 6.80535 17.3327 7.68884 17.9151 8.74816C18.4974 9.80749 18.7846 11.0038 18.7467 12.212C18.7087 13.4203 18.3469 14.5962 17.6992 15.6168L12 12V5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgressArc;
